import { render, staticRenderFns } from "./UploadProgress.vue?vue&type=template&id=44c1b5f6&scoped=true&"
import script from "./UploadProgress.vue?vue&type=script&lang=js&"
export * from "./UploadProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c1b5f6",
  null
  
)

export default component.exports